import axios from "axios";

const api_base_url = process.env.REACT_APP_API_BASEURL + "/OfficeAccount/";

// Get
export const getOfficeAccount = async () => {
  return axios.get(`${api_base_url}`);
};

//Add
export const addOfficeAccount = async (newData) => {
  const { data } = await axios.post(`${api_base_url}Add`, newData);
  return data;
};

//Update
export const updateOfficeAccount = async (updatedOfficeAccountData) => {
  const { data } = await axios.put(`${api_base_url}Update`, {
    ...updatedOfficeAccountData,
  });
  return data;
};

//Delete
export const deleteOfficeAccount = async (ids: number[]) => {
  const { data } = await axios.delete(`${api_base_url}Delete`, {
    data: ids,
  });
  return data;
};
